import type { Soru } from './tipler'

export const GENEL_SSS: Soru[] = [
  {
    soru: 'Kurulum ne kadar sürer?',
    cevap:
      'Dernek adı, ili ve amacını girdiğiniz anda paneliniz ve web siteniz açılır. Üye listenizi Excel’den aktarmak ve ödeme sağlayıcınızı bağlamak bir öğleden sonra sürer; kurulum sihirbazı adımları sırayla gösterir.',
  },
  {
    soru: 'Deneme süresinde kart bilgisi istiyor musunuz?',
    cevap:
      'Hayır. On dört gün boyunca elli üyeye kadar bütün çekirdek özellikleri kullanırsınız. Deneme bitince veriniz doksan gün saklanır; abone olursanız kaldığınız yerden devam edersiniz.',
  },
  {
    soru: 'Mevcut programımızdaki veriyi taşıyabilir miyiz?',
    cevap:
      'Üye ve aidat listesini Excel ya da CSV ile kendiniz aktarırsınız; bu ücretsizdir ve ön izlemeli çalışır. Eski bir yazılımın veritabanından taşıma ise teklife bağlı bir iştir; kapsamı birlikte belirleriz.',
  },
  {
    soru: 'Ödeme sağlayıcısı olarak kimlerle çalışıyorsunuz?',
    cevap:
      'PayTR, İyzico, Kuveyt Türk ve Param. Anlaşma dernekle sağlayıcı arasındadır; para doğrudan derneğin hesabına geçer, biz komisyon almayız.',
  },
  {
    soru: 'Verilerimiz nerede tutuluyor ve kim erişebilir?',
    cevap:
      'Türkiye’de, bize ait sunucularda. Her derneğin verisi veritabanı seviyesinde ayrılır; başka bir dernek ya da bizim personelimiz izinsiz göremez. Platform personelinin her erişimi denetim kaydına yazılır.',
  },
  {
    soru: 'Yıllık mı aylık mı ödeyelim?',
    cevap:
      'Yıllık ödemede iki ay bizden: on iki ay yerine on ay bedeli ödersiniz. Dernek bütçesi genel kurulda yıllık onaylandığı için çoğu dernek yıllık faturayı tercih ediyor.',
  },
  {
    soru: 'Sözleşmeyi bitirirsek verimizi alabilir miyiz?',
    cevap:
      'Evet, hem de her an: üye, aidat, ödeme, içerik ve belge verinizi açık biçimlerde dışa aktarırsınız. Sözleşme bitiminden sonra veri doksan gün saklanır, sonra imha edilir.',
  },
  {
    soru: 'DERBİS ile entegre misiniz?',
    cevap:
      'Hayır ve bunu iddia eden bir yazılım da bilmiyoruz; Bakanlık üçüncü taraf yazılımlara açık bir arayüz yayımlamış değil. Beyanname ve alındı belgesi için gereken veriyi hazır dökeriz; DERBİS’e girişi dernek yapar. İzin süreci açıldığında başvuracağız.',
  },
  {
    soru: 'Küçük bir derneğiz, bu kadar özellik bize fazla değil mi?',
    cevap:
      'Menü planınızdaki özelliklere göre şekillenir; kullanmadığınız modül önünüze çıkmaz. Başlangıç planı tam olarak bunun için var: üye, aidat, site ve portal.',
  },
  {
    soru: 'Destek nasıl çalışıyor?',
    cevap:
      'Panelden destek talebi açarsınız; iş günlerinde aynı gün yanıt veririz. Standart ve üzeri planlarda öncelikli, Pro ve Kurumsal’da telefonla destek vardır. Üyelerinizin talepleri ise size gelir, bize değil.',
  },
]
